module.exports = __webpack_public_path__ + "static/media/Espace-client-saham-assurance-AR.c02ed8d2.jpg";